import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import {
  getPeriodicityLabel,
  getProposalStateBadgeClass,
  getProposalStateLabel,
  ProposalState,
} from 'src/app/_enums/proposal.enums';
import { LanguageCode } from 'src/app/_helpers/nationalities';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { ProposalProductsDisplayerComponent } from '../proposal-products-displayer/proposal-products-displayer.component';

@Component({
  selector: 'app-proposal-displayer',
  templateUrl: './proposal-displayer.component.html',
  styleUrls: ['./proposal-displayer.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    IconsModule,
    ProposalProductsDisplayerComponent,
    RouterModule,
  ],
})
export class ProposalDisplayerComponent {
  @Input({ required: true }) offer!: ProposalDetails;

  @Input() showViewIcon = true;

  @Input() showActions = true;

  constructor(private readonly cookieService: CookieService) {}

  lngCode =
    (this.cookieService.get('selectedCountryCode') as LanguageCode) || 'fr';

  @Output() editProposal = new EventEmitter<ProposalDetails>();

  @Output() deleteProposal = new EventEmitter<string>();

  @Output() sendProposal = new EventEmitter<string>();

  @Output() viewDocument = new EventEmitter<string>();

  readonly ProposalState = ProposalState;

  readonly getProposalStateLabel = getProposalStateLabel;

  readonly getProposalStateBadgeClass = getProposalStateBadgeClass;

  readonly getInsuranceTypeLabel = getInsuranceTypeLabel;

  readonly getPeriodicityLabel = getPeriodicityLabel;
}
